/*
 *
 * Authorization API Reducer
 *
 */

import { NOT_ASKED, LOADING, SUCCESS, FAILURE, CLEAR } from './constants';

function reducer(state= {}, action) {
  switch (action.type) {
    case NOT_ASKED:
      return { status: NOT_ASKED, results: { loginType: '' } };
    case LOADING:
      return { status: LOADING, params: action.params, results: { loginType: '' } };
    case SUCCESS:
      return { ...state, status: SUCCESS, results: action.results };
    case FAILURE:
      return {
        ...state, status: FAILURE, error: action.error, results: { loginType: '' },
      };
    case CLEAR:
      return { status: CLEAR };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/services/LoginType/reducer.js